import {
	Button,
	designTokens,
	Grid,
	Input,
	Label,
	Pagination,
	TextLink
} from "@itandi/itandi-bb-ui";
import { Table } from "@itandi/itandi-bb-ui/Table";
import { Tbody } from "@itandi/itandi-bb-ui/Tbody";
import { Td } from "@itandi/itandi-bb-ui/Td";
import { Th } from "@itandi/itandi-bb-ui/Th";
import { Thead } from "@itandi/itandi-bb-ui/Thead";
import { Tr } from "@itandi/itandi-bb-ui/Tr";
import Link from "next/link";
import type { FC } from "react";
import { useCallback, useState } from "react";
import { useCompanySettings } from "~/hooks/vendors/useCompanySettings";
import type { CompanySettingWithItemSetting } from "~/models/CompanySetting";
import { getItemSettingLength } from "~/models/CompanySetting";
import type { VendorSession } from "~/models/VendorSession";
import { PATH as CONSTRUCTION_ITEM_SETTING_PATH } from "~/pages/vendors/settings/company_settings/[companyMasterId]/construction_item_settings";
import { VendorManagementCompanySettingModal } from "./vendor_management_company_settings/VendorManagementCompanySettingModal";

type Props = {
	session: VendorSession;
};

export const CompanySettingList: FC<Props> = ({ session }: Props) => {
	const [searchText, setSearchText] = useState("");
	const [pageNum, setPageNum] = useState(1);
	const [editingCompanySetting, setEditingCompanySetting] =
		useState<CompanySettingWithItemSetting | null>(null);
	const { data } = useCompanySettings().index(searchText, pageNum);

	const handleChangeSearchText = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			setSearchText(e.target.value);
			setPageNum(1);
		},
		[]
	);

	return (
		<>
			<Grid gap={designTokens["spacing/m"]}>
				<Input
					onChange={handleChangeSearchText}
					placeholder="管理会社名で検索"
					type="search"
					value={searchText}
					w="20rem"
				/>
				<Table>
					<Thead>
						<Tr>
							<Th>管理会社</Th>
							<Th width="6rem">設定</Th>
							<Th width="6rem">単価</Th>
						</Tr>
					</Thead>
					<Tbody>
						{data?.objects.map((companySetting) => (
							<Tr key={companySetting.companyMasterId}>
								<Td>
									<Label>{companySetting.name}</Label>
								</Td>
								<Td>
									<Button
										height="small"
										onClick={() => {
											setEditingCompanySetting(companySetting);
										}}
										variant="secondary"
									>
										編集
									</Button>
								</Td>
								<Td>
									<Grid gap={designTokens["spacing/xxs"]}>
										<TextLink
											as={Link}
											color="link"
											href={CONSTRUCTION_ITEM_SETTING_PATH(
												companySetting.companyMasterId
											)}
										>
											単価一覧
										</TextLink>
										<Label color="subtle" size="xs">
											{`${getItemSettingLength(
												companySetting.constructionItemSettings,
												session.vendorCompany.id
											)}件設定中`}
										</Label>
									</Grid>
								</Td>
							</Tr>
						))}
					</Tbody>
				</Table>
				{data !== null && (
					<Pagination
						currentPageNum={pageNum}
						maxPageNum={data.sumPageCount}
						onPageChange={(newPageNumber) => {
							setPageNum(newPageNumber);
						}}
					/>
				)}
			</Grid>
			{editingCompanySetting !== null && (
				<VendorManagementCompanySettingModal
					companySetting={editingCompanySetting}
					handleClose={() => {
						setEditingCompanySetting(null);
					}}
				/>
			)}
		</>
	);
};
